import { render, staticRenderFns } from "./ManifestVersions.vue?vue&type=template&id=5fe2c996&scoped=true&"
import script from "./ManifestVersions.vue?vue&type=script&lang=js&"
export * from "./ManifestVersions.vue?vue&type=script&lang=js&"
import style0 from "./ManifestVersions.vue?vue&type=style&index=0&id=5fe2c996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe2c996",
  null
  
)

export default component.exports